import { Chip } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';

import messages from './messages';
import { useStyles } from './styles';
import { OPENING, SubjectType } from './types';

interface SubjectTypeChipProps {
  subjectType: SubjectType | null | undefined;
  testId?: string;
}

/**
 * Whether this row is about an offer or an opening.
 *
 * One chip for the rule table and the approvals queue (AXHE-3934): the two sit on
 * adjacent tabs, and a reader who learns the green chip on one should not have to
 * learn it again on the other.
 *
 * The word carries the meaning and the tint reinforces it — a colourblind reader
 * gets "Offer" either way, which is why this is a labelled chip and not a
 * coloured dot. An unknown or absent type renders nothing rather than defaulting
 * to Offer: an unlabelled cell is a gap a reader can see, and a wrong label is
 * not.
 */
export const SubjectTypeChip: React.FC<SubjectTypeChipProps> = ({
  subjectType,
  testId,
}) => {
  const styles = useStyles();
  const intl = useIntl();

  if (!subjectType) return null;

  const isOpening = subjectType === OPENING;

  return (
    <Chip
      className={classNames(
        styles.typeChip,
        isOpening ? styles.typeOpening : styles.typeOffer,
      )}
      data-testid={testId}
      label={intl.formatMessage(
        isOpening ? messages.typeOpening : messages.typeOffer,
      )}
      size="small"
    />
  );
};
